<template>
    <credenciamento-esclarecimento-impugnacao-vazio v-if="naoPossuiEsclarecimentoImpugnacao"/>
    <div class="az-form-content" v-else>
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex>
                    <span class="az-subtitle primary--text">Esclarecimentos</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <v-data-table v-if="esclarecimentos.length > 0"
                                  :headers="colunasTabela"
                                  :items="esclarecimentos"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list table-dados-esclarecimentos-impugnacoes"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                    <span>{{ props.item.dataCadastro | azDate('DD/MM/YYYY HH:mm') }}</span>
                                </td>
                                <td>
                                    <span v-if="props.item && props.item.fornecedor && props.item.fornecedor.razaoSocial">
                                      {{ props.item.fornecedor.razaoSocial }}
                                    </span>
                                    <span v-else-if="props.item.nomeRazaoSocial">
                                      {{ props.item.nomeRazaoSocial }}
                                    </span>
                                    <span v-else>
                                      --
                                    </span>
                                </td>
                                <td class="d-inline-block text-truncate max-25" >{{ props.item.assunto }}</td>
                                <td>
                                    <span>{{ possuiAnexo(props.item) }}</span>
                                </td>
                                <td>{{ retornaSituacao(props.item.situacao) }}</td>
                                <td class="table-actions">
                                    <div>
                                        <div>
                                            <a @click="abrirModalVisualizacao(props.item)" title="Visualizar">
                                                <v-icon>search</v-icon>
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="!esclarecimentos.length">
                    <az-ops title="Nenhum esclarecimento encontrado."
                            message="Este processo não possui nenhum esclarecimento até o momento."
                    ></az-ops>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <span class="az-subtitle primary--text">Impugnações</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <v-data-table v-if="impugnacoes.length > 0"
                                  :headers="colunasTabela"
                                  :items="impugnacoes"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list table-dados-esclarecimentos-impugnacoes"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                              <td>
                                <span>{{ props.item.dataCadastro | azDate('DD/MM/YYYY HH:mm') }}</span>
                              </td>
                              <td>
                                <span v-if="props.item && props.item.fornecedor && props.item.fornecedor.razaoSocial">
                                      {{ props.item.fornecedor.razaoSocial }}
                                </span>
                                <span v-else-if="props.item.nomeRazaoSocial">
                                  {{ props.item.nomeRazaoSocial }}
                                </span>
                                <span v-else>
                                  --
                                </span>
                              </td>
                              <td class="d-inline-block text-truncate max-25" >{{ props.item.assunto }}</td>
                              <td>
                                <span>{{ possuiAnexo(props.item) }}</span>
                              </td>
                              <td>{{ retornaSituacao(props.item.situacao) }}</td>
                              <td class="table-actions">
                                <div>
                                  <div>
                                    <a @click="abrirModalVisualizacao(props.item)" title="Visualizar">
                                      <v-icon>search</v-icon>
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-flex xs12 sm12 d-flex v-if="!impugnacoes || !impugnacoes.length">
                        <az-ops title="Nenhuma impugnação encontrada."
                                message="Este processo não possui nenhuma impugnação até o momento."
                        ></az-ops>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
          <modal-visualizar-resposta-esclarecimento-impugnacao
                v-if="exibirModalDetalhe"
                v-model="exibirModalDetalhe"
                @fecharModalVisualizacao="exibirModalDetalhe = false"
                :item="selectedItem"
                />
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import ModalVisualizarRespostaEsclarecimentoImpugnacao
        from '../orgao/EsclarecimentoImpugnacao/Modal/ModalVisualizarRespostaEsclarecimentoImpugnacao.vue'
    import CredenciamentoEsclarecimentoImpugnacaoVazio
      from '@/views/credenciamento/detalhe-credenciamento/orgao/EsclarecimentoImpugnacao/CredenciamentoEsclarecimentoImpugnacaoVazio.vue'

    export default {
        name: 'EsclarecimentoImpugnacao',
        components: {
            ModalVisualizarRespostaEsclarecimentoImpugnacao,
            CredenciamentoEsclarecimentoImpugnacaoVazio},
        inject: ['$validator'],
        data() {
            return {
                colunasTabela: [
                    {
                        text: 'Data',
                        align: 'left',
                        sortable: true,
                        width: '15%',
                        class: 'primary--text',
                        value: 'dataCadastro'

                    },
                    {
                        text: 'Empresa/Nome',
                        align: 'left',
                        sortable: false,
                        width: '20%',
                        class: 'primary--text'
                    },
                    {
                        text: 'Assunto Esclarecimento',
                        align: 'left',
                        sortable: false,
                        width: '25%',
                        class: 'primary--text'
                    },
                    {
                        text: 'Anexo',
                        sortable: false,
                        align: 'left',
                        width: '10%',
                        class: 'primary--text'
                    },
                    {
                        text: 'Situação',
                        sortable: true,
                        align: 'left',
                        width: '20%',
                        class: 'primary--text',
                        value: 'situacao'
                    },
                    {
                        text: 'Ações',
                        sortable: false,
                        align: 'center',
                        width: '10%',
                        class: 'primary--text'
                    }
                ],
                licitacaoId: undefined,
                repository: 'repo1:licitacao',
                exibirModalDetalhe: false,
                selectedItem: undefined
            }
        },
        computed: {
            impugnacoes() {
               return this.impugnacoesLicitacao
            },
            esclarecimentos(){
                return this.esclarecimentosLicitacao;
            },
            naoPossuiEsclarecimentoImpugnacao() {
                return this.esclarecimentosLicitacao.length === 0 && this.impugnacoesLicitacao.length === 0
            },
            ...mapState(['loki', 'licitacao', 'anexosLicitacao', 'esclarecimentosLicitacao', 'impugnacoesLicitacao'])
        },
        methods: {
            retornaSituacao(situacao){
                if(situacao === 'AGUARDANDO'){
                    return 'Aguardando Resposta'
                } else {
                    return 'Respondido'
                }
            },
            possuiAnexo(item){
                if(item.arquivoUri){
                    return 'Sim'
                }else{
                    return 'Não'
                }
            },
            abrirModalVisualizacao(item){
                this.selectedItem = item
                this.exibirModalDetalhe = true
            }
        }
    }
</script>

<style scoped lang="stylus">
    .table-dados-esclarecimentos-impugnacoes
        td
            color #777 !important
        padding-bottom: 50px

    .table-status
        &__error i
            font-size: 18px
            color: #d79641

    @media (max-width: 720px)
        .table-dados-esclarecimentos-impugnacoes

            td:nth-of-type(1):before
                display none

            td:nth-of-type(2):before
                content: "Tipo:"

            td:nth-of-type(3):before
                content: "Data:"

            td:nth-of-type(4):before
                content: "Nome:"

            td:nth-of-type(5):before
                display none

</style>
